import { useStore } from 'hooks/useStore';
import { useEffect, useRef, useState } from 'react';
import { tmsScreenServices } from 'services/tmsScreenServices';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { salesplanEditInterface } from 'Interfaces/FDPInterfaces/tmsInterfaces';
import { getCurrentMonthDate } from 'utils/dateUtilities';

type valueTypeInterface = 'saved' | 'old' | 'forecast';

export const useSalesPlanEdit = () => {
  const {
    UserStore: { userModulesRoles },
    MSPlanStore: {
      conceptDetails,
      isSalesDetailsLoading,
      SalesPlansalesSummaryData: salesSummaryData,
      salesplanEditData,
      summaryVisibility,
      istmsUpdateLoading,
      isTMSNotesDataLoading,
      isConceptLoading,
      isConceptDetailsLoading,
      isSalesPlanEditDataLoading,
      isSalesPlanUpdating,
      contractDetails,
      salesPlanError,
      isMSplanNoteSaving,
      tmsNotesData,
      oldsalesplanEditData,
      // cotsWithNullOldData,
      fetchSalesPlanData: _fetchSalesPlanData,
      savePlanNote,
      saveSalesPlanData,
      fetchSalesProgress,
      fetchMSPlanBulkUpdategfcs,
      fetchSalesPlanEditData,
      toggleSummaryModalVisibility,
      updteOldSPValues,
      setNoteData,
      removeNoteData,
    },
    NavbarStore: { isNavigationRestricted, setisNavigationRestricted },
  } = useStore();

  const [directCOT, setDirectCOT] = useState<{
    label: string;
    value: string;
  }>({ label: 'CMOP', value: 'cmop' });
  const [indirectCOT, setIndirectCOT] = useState<{
    label: string;
    value: string;
  }>({ label: 'CMOP', value: 'cmop' });
  const [isDirect, setIsDirect] = useState<boolean>(true);
  const [isDirectFinish, setIsDirectFinish] = useState<boolean>(true);
  const [savingAll, setSavingAll] = useState<boolean>(false);
  const [savingSingle, setSavingSingle] = useState<boolean>(false);
  const [finishStatus, setFinishStatus] = useState<boolean>(false);
  const [sellingCategoryCotsHavingOldValues, setSellingCategoryCotsHavingOldValues] = useState<
    Set<string>
  >(new Set());
  const [popup, setPopup] = useState<boolean>(false);
  const [confirmPopup, setConfirmPopup] = useState<boolean>(false);
  const [singleSavepopup, setSingleSavepopup] = useState<boolean>(false);
  const [singleconfirmPopup, setSingleConfirmPopup] = useState<boolean>(false);
  const [finishConfirmVisibility, setFinishConfirmVisibility] = useState<boolean>(false);
  const [finishConfirmpopup, setFinishConfirmpopup] = useState<boolean>(false);
  const [copyRowInfo, setCopyRowInfo] = useState<Set<string>>(new Set());
  const [cotValueTypeUsing, setCotValueTypeUsing] = useState<Map<string, valueTypeInterface>>(
    new Map()
  );
  const [isNoteEdited, setIsNoteEdited] = useState<Map<number, boolean>>(new Map());
  const [isNoteDeleted, setIsNoteDeleted] = useState<Map<number, boolean>>(new Map());
  const [_currentFocusedRow, _setCurrentFocusedRow] = useState<Set<string>>(new Set());

  const cots: { cot: string; value: string }[] = [
    { value: 'cmop', cot: 'CMOP' },
    { value: 'va facility', cot: 'VA Facility' },
    { value: 'tmop', cot: 'TMOP' },
    { value: 'mtf', cot: 'MTF' },
  ];
  const [lastMSInput, setLastMSInput] = useState([
    { cot: 'CMOP', val: -1 },
    { cot: 'VA Facility', val: -1 },
    { cot: 'TMOP', val: -1 },
    { cot: 'MTF', val: -1 },
  ]);
  const [_copyAll, _setCopyAll] = useState([
    { cot: 'CMOP', check: false },
    { cot: 'VA Facility', check: false },
    { cot: 'TMOP', check: false },
    { cot: 'MTF', check: false },
  ]);

  const directInputFocus = useRef<HTMLInputElement[]>([]);
  const indirectInputFocus = useRef<HTMLInputElement[]>([]);
  const [directFocused, setDirectFocused] = useState<number | null>(null);
  const [indirectFocused, setIndirectFocused] = useState<number | null>(null);

  const navigate = useNavigate();

  useEffect(() => {
    if (conceptDetails?.gfc) {
      console.log('sales plan api called');
      fetchSalesPlanEditData(getCurrentMonthDate(), conceptDetails.gfc);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    setisNavigationRestricted(true);

    return () => {
      setisNavigationRestricted(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // get future 15 months date
  const getFutureMonths = () => {
    const arr: { label: string; dateString: string }[] = [];
    const dt = new Date();
    const startMonth = dt.getMonth();
    const startYear = dt.getFullYear();
    const monthShortHand = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    for (let i = 0; i < 15; i++) {
      const month = (startMonth + i + 1) % 12;
      const year = startYear + Math.floor((startMonth + i + 1) / 12);
      arr.push({
        label: `${monthShortHand[month]}-${year}`,
        dateString: `${year}-${month >= 9 ? month + 1 : `0${month + 1}`}-01`,
      });
    }

    return arr;
  };
  const futureDates: { label: string; dateString: string }[] = getFutureMonths();

  const handleNavigateToViewScreen = () => {
    if (
      isNavigationRestricted &&
      salesplanEditData.length > 0 &&
      salesplanEditData.toString() !== oldsalesplanEditData.toString()
    ) {
      if (
        window.confirm(`Are you sure want to navigate?,
Unsaved Changes will be discarded!`) // intensional removal of indentation for getting proper formatted message in the alert
      ) {
        navigate(`/fdp/target_market?gfc=${conceptDetails?.gfc}`);
      }
    } else {
      navigate(`/fdp/target_market?gfc=${conceptDetails?.gfc}`);
    }
  };

  const getSalesSummaryVal = (cot: string, type: string, cat: string) => {
    if (isSalesDetailsLoading) return undefined;

    // Handle cases where data might be undefined or empty
    if (!salesSummaryData || salesSummaryData.length === 0) {
      return 'NA';
    }

    const val = salesSummaryData.find(item => item.COT.toLowerCase() === cot.toLowerCase());
    if (!val) return 'NA';

    switch (type) {
      case 'YTD':
        if (cat === 'direct') {
          if (val.TotalAnnualSalesVolumeDirect !== null) {
            if (val.TotalAnnualSalesVolumeDirect === 0) return val.TotalAnnualSalesVolumeDirect;
            return val.TotalAnnualSalesVolumeDirect;
          } else {
            return 'NA';
          }
        } else if (cat === 'indirect') {
          if (val.TotalAnnualSalesVolumeIndirect !== null) {
            if (val.TotalAnnualSalesVolumeIndirect === 0) return val.TotalAnnualSalesVolumeIndirect;
            return val.TotalAnnualSalesVolumeIndirect;
          } else {
            return 'NA';
          }
        }
        break;
      case '3MA':
        if (cat === 'direct') {
          if (val.LastThreeMonthAvgDirect !== null) {
            if (val.LastThreeMonthAvgDirect === 0) return val.LastThreeMonthAvgDirect;
            return val.LastThreeMonthAvgDirect;
          } else {
            return 'NA';
          }
        } else if (cat === 'indirect') {
          if (val.LastThreeMonthAvgIndirect !== null) {
            if (val.LastThreeMonthAvgIndirect === 0) return val.LastThreeMonthAvgIndirect;
            return val.LastThreeMonthAvgIndirect;
          } else {
            return 'NA';
          }
        }
        break;
      case 'PM':
        if (cat === 'direct') {
          if (val.LastMonthSalesVolumeDirect !== null) {
            if (val.LastMonthSalesVolumeDirect === 0) return val.LastMonthSalesVolumeDirect;
            return val.LastMonthSalesVolumeDirect;
          } else {
            return 'NA';
          }
        } else if (cat === 'indirect') {
          if (val.LastMonthSalesVolumeIndirect !== null) {
            if (val.LastMonthSalesVolumeIndirect === 0) return val.LastMonthSalesVolumeIndirect;
            return val.LastMonthSalesVolumeIndirect;
          } else {
            return 'NA';
          }
        }
        break;
      default:
        return 'NA';
    }
  };

  const getRoundedValueForMSPlan = (value: string) => {
    return Math.round(parseFloat(value) * 100);
  };

  const getSalesplanValue = (cot: string, cat: string, planningPeriod: string, need: string) => {
    const normalizeString = (str: string) => str.toLowerCase();
    const findSalesplanData = (month: string) => {
      return salesplanEditData.filter(
        item =>
          normalizeString(item.COT) === normalizeString(cot) &&
          normalizeString(item.SellingCategory) === normalizeString(cat) &&
          item.PlanningMonth === month
      );
    };
    let salesplanCurrentData = findSalesplanData(planningPeriod);
    if (salesplanCurrentData.length === 0) {
      const previousMonth = new Date(planningPeriod);
      const maxIteration = 12;
      for (let iteration = 0; iteration < maxIteration; iteration++) {
        previousMonth.setMonth(previousMonth.getMonth() - 1);
        const prevPlanningDate =
          previousMonth.toISOString().split('T')[0].split('-').slice(0, 2).join('-') + '-01';
        salesplanCurrentData = findSalesplanData(prevPlanningDate);
        if (salesplanCurrentData.length > 0) break;
      }
    }
    if (salesplanCurrentData.length === 0) {
      return '-';
    }
    const salesplanData = salesplanCurrentData[0];
    if (need === 'marketForecast') {
      const val = salesplanData.ActiveMarketForecasts;
      return typeof val === 'number' ? val.toLocaleString('en-US') : val;
    } else if (need === 'adjforecast') {
      let adjVal;
      if (cotValueTypeUsing.get(cot.toLowerCase() + cat.toLowerCase()) === 'forecast') {
        adjVal = salesplanData.AdjustedMarketForecast;
      } else if (cotValueTypeUsing.get(cot.toLowerCase() + cat.toLowerCase()) === 'old') {
        adjVal = salesplanData.OldAdjustments;
      } else {
        adjVal = salesplanData.SavedAdjustments;
      }
      return typeof adjVal === 'number' ? adjVal.toLocaleString('en-US') : adjVal;
    } else if (need === 'tmsvalue') {
      return `${salesplanData.TargetMarketShare}%`;
    } else if (need === 'msplan') {
      return `${getRoundedValueForMSPlan(String(salesplanData.MarketShareAdjustment))}%`;
    } else if (need === 'euforecast') {
      let euVal;
      if (cotValueTypeUsing.get(cot.toLowerCase() + cat.toLowerCase()) === 'forecast') {
        euVal = Math.ceil(salesplanData.AdjustedMarketForecast * salesplanData.MarketShareAdjustment);
      } else if (cotValueTypeUsing.get(cot.toLowerCase() + cat.toLowerCase()) === 'old') {
        euVal = Math.ceil((salesplanData.OldAdjustments || 0) * salesplanData.MarketShareAdjustment);
      } else {
        euVal = Math.ceil((salesplanData.SavedAdjustments || 0) * salesplanData.MarketShareAdjustment);
      }
      return euVal.toLocaleString('en-US');
    } else {
      return '-';
    }
  };

  function isNumeric(value: string) {
    return /^[0-9]{1,9}$/.test(value);
  }

  const updateForecastValue = (
    adj: string,
    planningPeriod: string,
    cot: string,
    isDirect: boolean
  ) => {
    // Check if the adjustment is numeric or an empty string
    if ((isNumeric(adj) && parseFloat(adj) >= 0) || adj === '') {
      const numericAdj = adj === '' ? 0 : parseFloat(adj); // Convert adj to a number or default to 0
      // Single pass to update matching items
      for (const item of salesplanEditData) {
        if (item.PlanningMonth === planningPeriod && item.COT.toLowerCase() === cot.toLowerCase()) {
          if (
            cotValueTypeUsing.get(cot.toLowerCase() + (isDirect ? 'direct' : 'indirect')) ===
            'forecast'
          ) {
            item.AdjustedMarketForecast = numericAdj;
          } else if (
            cotValueTypeUsing.get(cot.toLowerCase() + (isDirect ? 'direct' : 'indirect')) ===
            'saved'
          ) {
            item.SavedAdjustments = numericAdj;
          } else {
            item.OldAdjustments = numericAdj;
          }
          item.EUForecast = Math.ceil(numericAdj * item.MarketShareAdjustment);
        }
      }
      if (
        !(
          isOldValuesCheckBoxChecked(directCOT.label.toLowerCase(), true) ||
          isOldValuesCheckBoxChecked(directCOT.label.toLowerCase(), false)
        )
      )
        setLastMSInput(prev =>
          prev.map(item =>
            item.cot.toLowerCase() === cot.toLowerCase() ? { ...item, val: parseFloat(adj) } : item
          )
        );
    }
  };

  const updateEUForecastValue = (adj: string, planningPeriod: string, cot: string) => {
    for (const item of salesplanEditData) {
      if (item.PlanningMonth === planningPeriod && item.COT.toLowerCase() === cot.toLowerCase()) {
        const forecast = Math.round(Number(adj) * item.MarketShareAdjustment);
        item.EUForecast = forecast;
      }
    }
    calculateOverallMS();
  };

  // function to calculate overall Market Share
  const calculateOverallMS = () => {
    let adjustmentSum: number = 0;
    let euForecastSum: number = 0;

    const futureDateSet = new Set(futureDates.map(({ dateString }) => dateString)); // Use Set for O(1) lookup

    for (const item of salesplanEditData) {
      let euforecast = 0;
      let adjustment = 0;
      if (cotValueTypeUsing.get(item.COT.toLowerCase() + item.SellingCategory) === 'forecast') {
        euforecast = Math.ceil(item.ActiveMarketForecasts * item.MarketShareAdjustment);
        adjustment = item.AdjustedMarketForecast;
      } else if (cotValueTypeUsing.get(item.COT.toLowerCase() + item.SellingCategory) === 'old') {
        euforecast = Math.ceil((item.OldAdjustments || 0) * item.MarketShareAdjustment);
        adjustment = item.OldAdjustments || 0;
      } else {
        euforecast = Math.ceil((item.SavedAdjustments || 0) * item.MarketShareAdjustment);
        adjustment = item.SavedAdjustments || 0;
      }
      if (futureDateSet.has(item.PlanningMonth)) {
        if (item.SellingCategory.toLowerCase() === 'direct') {
          adjustmentSum += adjustment;
          euForecastSum += euforecast;
        }
      }
    }

    if (euForecastSum === 0) {
      for (const item of salesplanEditData) {
        let euforecast = 0;
        let adjustment = 0;
        if (cotValueTypeUsing.get(item.COT.toLowerCase() + item.SellingCategory) === 'forecast') {
          euforecast = Math.ceil(item.ActiveMarketForecasts * item.MarketShareAdjustment);
          adjustment = item.AdjustedMarketForecast;
        } else if (cotValueTypeUsing.get(item.COT.toLowerCase() + item.SellingCategory) === 'old') {
          euforecast = Math.ceil((item.OldAdjustments || 0) * item.MarketShareAdjustment);
          adjustment = item.OldAdjustments || 0;
        } else {
          euforecast = Math.ceil((item.SavedAdjustments || 0) * item.MarketShareAdjustment);
          adjustment = item.SavedAdjustments || 0;
        }
        if (futureDateSet.has(item.PlanningMonth)) {
          if (item.SellingCategory.toLowerCase() === 'indirect') {
            adjustmentSum += adjustment;
            euForecastSum += euforecast;
          }
        }
      }
    }
    return Math.round((euForecastSum / adjustmentSum) * 100)
      ? String(Math.round((euForecastSum / adjustmentSum) * 100))
      : 0;
  };

  const getCurrentDate = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    return `${year}-${month}-01`;
  };

  const handleSingleSave = async () => {
    const payload: {
      MarketShareAdjustment: number;
      Month: string;
      Adjustment: number;
      SalesPlan: number;
      Note: string;
      PlanningPeriod: string;
      MarketSalesForecast: string;
    }[] = [];

    const category = isDirect ? 'direct' : 'indirect';
    const selectedcot = isDirect ? directCOT.value : indirectCOT.value;

    const oldSelectedPlanData: salesplanEditInterface[] = [];
    const selectedplans = salesplanEditData.filter((item, index) => {
      if (
        item.COT.toLowerCase() === selectedcot.toLowerCase() &&
        item.SellingCategory.toLowerCase() === category
      ) {
        oldSelectedPlanData.push(oldsalesplanEditData[index]);
        return true;
      }
      return false;
    });

    const planning_period = getCurrentDate();

    for (const plan of selectedplans) {
      if (plan.MarketShareAdjustment === null) {
        continue;
      } else {
        let euforecast = 0;
        let adjustment = 0;
        if (cotValueTypeUsing.get(plan.COT.toLowerCase() + plan.SellingCategory) === 'forecast') {
          euforecast = Math.ceil(plan.ActiveMarketForecasts * plan.MarketShareAdjustment);
          adjustment = plan.AdjustedMarketForecast;
        } else if (cotValueTypeUsing.get(plan.COT.toLowerCase() + plan.SellingCategory) === 'old') {
          euforecast = Math.ceil((plan.OldAdjustments || 0) * plan.MarketShareAdjustment);
          adjustment = plan.OldAdjustments || 0;
        } else {
          euforecast = Math.ceil((plan.SavedAdjustments || 0) * plan.MarketShareAdjustment);
          adjustment = plan.SavedAdjustments || 0;
        }

        const obj = {
          MarketShareAdjustment: plan.MarketShareAdjustmentID,
          Month: plan.PlanningMonth,
          Adjustment: adjustment - plan.ActiveMarketForecasts,
          SalesPlan: euforecast,
          Note: 'sales plan',
          PlanningPeriod: planning_period,
          MarketSalesForecast: String(plan.ActiveMarketForecasts),
        };
        payload.push(obj);
      }
    }

    try {
      setSavingSingle(true);
      await tmsScreenServices.updateSalesPlanData(payload);
      updteOldSPValues();
    } catch (error) {
      console.log('handleSingleSave=> ', error);
    } finally {
      setSavingSingle(false);
      setCopyRowInfo(new Set());
    }
  };

  const handleSaveAllSalesPlan = async () => {
    const payload: {
      MarketShareAdjustment: number;
      Month: string;
      Adjustment: number;
      SalesPlan: number;
      Note: string;
      PlanningPeriod: string;
      MarketSalesForecast: string;
    }[] = [];
    const planning_period = getCurrentDate();
    for (const plan of salesplanEditData) {
      if (plan.MarketShareAdjustmentID === null) {
        continue;
      } else {
        let euforecast = 0;
        let adjustment = 0;
        if (cotValueTypeUsing.get(plan.COT.toLowerCase() + plan.SellingCategory) === 'forecast') {
          euforecast = Math.ceil(plan.ActiveMarketForecasts * plan.MarketShareAdjustment);
          adjustment = plan.AdjustedMarketForecast;
        } else if (cotValueTypeUsing.get(plan.COT.toLowerCase() + plan.SellingCategory) === 'old') {
          euforecast = Math.ceil((plan.OldAdjustments || 0) * plan.MarketShareAdjustment);
          adjustment = plan.OldAdjustments || 0;
        } else {
          euforecast = Math.ceil((plan.SavedAdjustments || 0) * plan.MarketShareAdjustment);
          adjustment = plan.SavedAdjustments || 0;
        }
        const output = {
          MarketShareAdjustment: plan.MarketShareAdjustmentID,
          Month: plan.PlanningMonth,
          Adjustment: adjustment - plan.ActiveMarketForecasts,
          SalesPlan: euforecast,
          Note: 'sales plan',
          PlanningPeriod: planning_period,
          MarketSalesForecast: String(plan.ActiveMarketForecasts),
        };
        payload.push(output);
      }
    }

    try {
      setSavingAll(true);
      await saveSalesPlanData(payload);
      updteOldSPValues();
    } catch (error) {
      console.log('handleSaveAllSalesPlan=> ', error);
    } finally {
      if (!salesPlanError) {
        // handleNavigateToViewScreen();
        navigate(`/fdp/target_market?gfc=${conceptDetails?.gfc}`);
        fetchSalesProgress();
        fetchMSPlanBulkUpdategfcs();
      }
      setSavingAll(false);
      setCopyRowInfo(new Set());
    }
  };

  const handleFinishSalesplan = async () => {
    // if (!isSalesplanNoteSaved) {
    //   toast.error('Note not added.');
    //   return;
    // }

    const payload: {
      MarketShareAdjustment: number;
      Month: string;
      Adjustment: number;
      SalesPlan: number;
      Note: string;
      PlanningPeriod: string;
      MarketSalesForecast: string;
    }[] = [];

    const category = isDirect ? 'direct' : 'indirect';
    const oldSelectedPlanData: salesplanEditInterface[] = [];

    const selectedplans = salesplanEditData.filter((item, index) => {
      if (item.SellingCategory.toLowerCase() === category) {
        oldSelectedPlanData.push(oldsalesplanEditData[index]);
        return true;
      }
      return false;
    });
    const planning_period = getCurrentDate();

    for (const plan of selectedplans) {
      if (plan.MarketShareAdjustment === null) {
        continue;
      } else {
        let euforecast = 0;
        let adjustment = 0;
        if (cotValueTypeUsing.get(plan.COT.toLowerCase() + plan.SellingCategory) === 'forecast') {
          euforecast = Math.ceil(plan.ActiveMarketForecasts * plan.MarketShareAdjustment);
          adjustment = plan.AdjustedMarketForecast;
        } else if (cotValueTypeUsing.get(plan.COT.toLowerCase() + plan.SellingCategory) === 'old') {
          euforecast = Math.ceil((plan.OldAdjustments || 0) * plan.MarketShareAdjustment);
          adjustment = plan.OldAdjustments || 0;
        } else {
          euforecast = Math.ceil((plan.SavedAdjustments || 0) * plan.MarketShareAdjustment);
          adjustment = plan.SavedAdjustments || 0;
        }

        const obj = {
          MarketShareAdjustment: plan.MarketShareAdjustmentID,
          Month: plan.PlanningMonth,
          Adjustment: adjustment - plan.ActiveMarketForecasts,
          SalesPlan: euforecast,
          Note: 'sales plan',
          PlanningPeriod: planning_period,
          MarketSalesForecast: String(plan.ActiveMarketForecasts),
        };
        payload.push(obj);
      }
    }

    try {
      setFinishStatus(true);
      await tmsScreenServices.updateSalesPlanData(payload);
      updteOldSPValues();
    } catch (error) {
      console.log('handleSingleSave=> ', error);
    } finally {
      setFinishStatus(false);
      setFinishConfirmVisibility(false);
      setFinishConfirmpopup(false);
      setCopyRowInfo(new Set());
    }
  };

  const checkFinishStatus = () => {
    let count = 0;
    for (const plan of salesplanEditData) {
      if (plan.MarketShareAdjustmentID === null && plan.EUForecast === 0) {
        count++;
      }
    }

    if (count === salesplanEditData.length) {
      return true;
    } else {
      return false;
    }
  };

  const checkSaveStatus = (cot: string) => {
    const cotData = salesplanEditData.filter(
      item => item.COT.toLocaleLowerCase() === cot.toLocaleLowerCase()
    );

    let count = 0;
    for (const plan of cotData) {
      if (plan.MarketShareAdjustmentID === null && plan.EUForecast === 0) {
        count++;
      }
    }

    if (count === cotData.length) {
      return true;
    } else {
      return false;
    }
  };

  const isOldValueCheckBoxVisible = (cot: string, isDirect: boolean) => {
    // check whether we can even toggle it or not
    if (cotValueTypeUsing.get(cot.toLowerCase() + (isDirect ? 'direct' : 'indirect')) === 'saved')
      return false;

    if (
      !sellingCategoryCotsHavingOldValues.has(
        cot.toLowerCase() + (isDirect ? 'direct' : 'indirect')
      )
    ) {
      return false;
    }

    return true;
  };

  const isOldValuesCheckBoxChecked = (cot: string, isDirect: boolean) => {
    return cotValueTypeUsing.get(cot.toLowerCase() + (isDirect ? 'direct' : 'indirect')) === 'old'
      ? true
      : false;
  };

  const toggleOldValuesChekedSwitch = (cot: string, isDirect: boolean) => {
    const tempCotValueTypeUsing: Map<string, valueTypeInterface> = new Map(cotValueTypeUsing);
    if (
      tempCotValueTypeUsing.get(cot.toLowerCase() + (isDirect ? 'direct' : 'indirect')) === 'old'
    ) {
      tempCotValueTypeUsing.set(cot.toLowerCase() + (isDirect ? 'direct' : 'indirect'), 'forecast');
    } else {
      tempCotValueTypeUsing.set(cot.toLowerCase() + (isDirect ? 'direct' : 'indirect'), 'old');
    }
    setCotValueTypeUsing(tempCotValueTypeUsing);
  };

  const handleNoteAdd = (value: string) => {
    try {
      if (value.trim() === '') {
        toast.warning('Cannot save an empty note!!');
      } else if (conceptDetails && conceptDetails.gfc) {
        savePlanNote(Number(conceptDetails?.gfc), value, 'sales plan', 'salesplan');
      }
    } catch (_error) {
      toast.error('Could not save the note, please try again later');
    }
  };

  const handleEditNote = async (id: number, note: string) => {
    try {
      setIsNoteEdited(prev => {
        const temp = new Map(prev);
        if (temp.has(id)) {
          temp.set(id, true);
        } else {
          temp.set(id, true);
        }
        return temp;
      });
      const data = await tmsScreenServices.updateNote(id, note);
      if (data) {
        toast.success('Note Updated successfully.');
      }
    } catch (error) {
      console.log('handleEditNote=> ', error);
      toast.error('Something went wrong.');
    } finally {
      setIsNoteEdited(prev => {
        const temp = new Map(prev);
        if (temp.has(id)) {
          temp.set(id, false);
        } else {
          temp.set(id, false);
        }
        return temp;
      });
    }
  };

  const handleDeleteNote = async (id: number) => {
    try {
      setIsNoteDeleted(prev => {
        const temp = new Map(prev);
        if (temp.has(id)) {
          temp.set(id, true);
        } else {
          temp.set(id, true);
        }
        return temp;
      });
      const data = await tmsScreenServices.deleteNote(id);
      if (data) {
        removeNoteData(id);
        toast.success('Note deleted successfully.');
      }
    } catch (error) {
      console.log('handleEditNote=> ', error);
      toast.error('Something went wrong.');
    } finally {
      setIsNoteDeleted(prev => {
        const temp = new Map(prev);
        if (temp.has(id)) {
          temp.set(id, false);
        } else {
          temp.set(id, false);
        }
        return temp;
      });
    }
  };

  const handleCopyButtonClick = (isDirect: boolean, monthIndex: number) => {
    if (monthIndex <= futureDates.length - 1) {
      const cot = isDirect ? directCOT.value : indirectCOT.value;
      const cat = isDirect ? 'direct' : 'indirect';
      const rawVal = getSalesplanValue(cot, cat, futureDates[monthIndex].dateString, 'adjforecast');

      if (rawVal === '-' || rawVal === '' || rawVal === null || rawVal === undefined) {
        toast.error(`Empty value cannot be copied`);
        return;
      }

      // getSalesplanValue returns a locale-formatted string (e.g. "1,000"); strip the
      // thousands separators so updateForecastValue's numeric validation accepts it.
      const val = String(rawVal).replace(/,/g, '');

      for (let i = monthIndex + 1; i < futureDates.length; i++) {
        updateForecastValue(val, futureDates[i].dateString, cot, isDirect);
      }
      const tempInfo = new Set([
        cot.toLowerCase() + futureDates[monthIndex].dateString + cat.toLowerCase(),
      ]);
      setCopyRowInfo(tempInfo);
      toast.success(`Copied ${val} to all rows`);
    }
  };

  const handleResetButtonClick = (isDirect: boolean, monthIndex: number) => {
    if (monthIndex <= futureDates.length - 1) {
      const cot = isDirect ? directCOT.value : indirectCOT.value;
      const sell_cat: string = isDirect ? 'direct' : 'indirect';

      const getAdjSalesPlan = (
        data: salesplanEditInterface[],
        cot: string,
        month: string,
        category: string
      ) => {
        const dataItem = data.filter(
          item =>
            item.COT.toLowerCase() === cot.toLowerCase() &&
            item.PlanningMonth === month &&
            item.SellingCategory.toLowerCase() === category.toLowerCase()
        );

        if (cotValueTypeUsing.get(cot.toLowerCase() + category.toLowerCase()) === 'forecast') {
          return dataItem[0].AdjustedMarketForecast;
        } else if (cotValueTypeUsing.get(cot.toLowerCase() + category.toLowerCase()) === 'old') {
          return dataItem[0].OldAdjustments;
        } else {
          return dataItem[0].SavedAdjustments;
        }
      };

      for (let i = monthIndex; i < futureDates.length; i++) {
        const planning_period = futureDates[i].dateString;

        const oldVal = getAdjSalesPlan(oldsalesplanEditData, cot, planning_period, sell_cat);

        if (oldVal !== null) {
          updateForecastValue(
            oldVal.toString(),
            planning_period,
            cot,
            sell_cat === 'direct' ? true : false
          );
        }
      }
      setCopyRowInfo(new Set());
      toast.success('Restored values to default values');
    }
  };

  // const setFocusedRowItem = (
  //   forecastPeriod: string,
  //   marketForecast: string
  // ) => {
  //   const item = `${forecastPeriod}-${marketForecast}`;
  //   if (!currentFocusedRow.has(item)) {
  //     const tempSet = new Set(currentFocusedRow);
  //     tempSet.add(item);
  //     setCurrentFocusedRow(tempSet);
  //   } else {
  //     return;
  //   }
  // };

  // const removeFocusedRowItem = (
  //   forecastPeriod: string,
  //   marketForecast: string
  // ) => {
  //   const item = `${forecastPeriod}-${marketForecast}`;
  //   if (currentFocusedRow.has(item)) {
  //     const tempSet = new Set(currentFocusedRow);
  //     tempSet.delete(item);
  //     setCurrentFocusedRow(tempSet);
  //   } else {
  //     return;
  //   }
  // };

  // const checkIfRowInputFocused = (
  //   forecastPeriod: string,
  //   marketForecast: string
  // ) => {
  //   const item = `${forecastPeriod}-${marketForecast}`;
  //   return currentFocusedRow.has(item);
  // };

  const handleDirectKeyPress = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      if (index < futureDates.length - 1) {
        directInputFocus.current[index + 1]?.focus();
      }
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (index > 0) {
        directInputFocus.current[index - 1]?.focus();
      }
    }
  };

  const handleIndirectKeyPress = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      if (index < futureDates.length - 1) {
        indirectInputFocus.current[index + 1]?.focus();
      }
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (index > 0) {
        indirectInputFocus.current[index - 1]?.focus();
      }
    }
  };

  const handleDirectFocus = (index: number) => {
    setDirectFocused(index);
  };

  const handleIndirectFocus = (index: number) => {
    setIndirectFocused(index);
  };

  const handleDirectBlur = () => {
    setDirectFocused(null);
  };

  const handleIndirectBlur = () => {
    setIndirectFocused(null);
  };

  useEffect(() => {
    const tempusingOldValuesCotsDirect: Set<string> = new Set();
    const tempCotValueTypeUsing: Map<string, valueTypeInterface> = new Map();

    salesplanEditData.forEach(data => {
      if (data.isSavedSalesAvailable) {
        tempCotValueTypeUsing.set(
          data.COT.toLowerCase() + data.SellingCategory.toLowerCase(),
          'saved'
        );
      } else if (data.isOldSalesAvailable) {
        tempCotValueTypeUsing.set(
          data.COT.toLowerCase() + data.SellingCategory.toLowerCase(),
          'old'
        );
        tempusingOldValuesCotsDirect.add(
          data.COT.toLowerCase() + data.SellingCategory.toLowerCase()
        );
      } else {
        tempCotValueTypeUsing.set(
          data.COT.toLowerCase() + data.SellingCategory.toLowerCase(),
          'forecast'
        );
      }
    });

    setCotValueTypeUsing(tempCotValueTypeUsing);
    setSellingCategoryCotsHavingOldValues(tempusingOldValuesCotsDirect);
  }, [salesplanEditData, isSalesPlanEditDataLoading]);

  return {
    userModulesRoles,
    conceptDetails,
    directCOT,
    cots,
    futureDates,
    savingAll,
    savingSingle,
    isSalesDetailsLoading,
    summaryVisibility,
    istmsUpdateLoading,
    isSalesPlanUpdating,
    isTMSNotesDataLoading,
    isConceptLoading,
    isSalesPlanEditDataLoading,
    salesplanEditData,
    contractDetails,
    isConceptDetailsLoading,
    popup,
    confirmPopup,
    singleSavepopup,
    singleconfirmPopup,
    lastMSInput,
    indirectCOT,
    finishConfirmVisibility,
    setFinishConfirmVisibility,
    finishConfirmpopup,
    setFinishConfirmpopup,
    isDirectFinish,
    setIsDirectFinish,
    setIndirectCOT,
    setSingleConfirmPopup,
    setSingleSavepopup,
    setConfirmPopup,
    setPopup,
    setDirectCOT,
    getSalesSummaryVal,
    getSalesplanValue,
    getSalesplanIsDeramped: (cot: string, cat: string, planningPeriod: string): boolean => {
      const entry = salesplanEditData.find(
        item =>
          item.COT.toLowerCase() === cot.toLowerCase() &&
          item.SellingCategory.toLowerCase() === cat.toLowerCase() &&
          item.PlanningMonth === planningPeriod,
      );
      return entry?.is_deramped === true;
    },
    updateForecastValue,
    updateEUForecastValue,
    toggleSummaryModalVisibility,
    handleSaveAllSalesPlan,
    handleFinishSalesplan,
    handleSingleSave,
    calculateOverallMS,
    isOldValueCheckBoxVisible,
    isOldValuesCheckBoxChecked,
    toggleOldValuesChekedSwitch,
    handleNavigateToViewScreen,
    fetchSalesPlanEditData,
    checkFinishStatus,
    checkSaveStatus,
    isMSplanNoteSaving,
    tmsNotesData,
    handleNoteAdd,
    handleCopyButtonClick,
    handleResetButtonClick,
    isDirect,
    setIsDirect,
    finishStatus,
    copyRowInfo,
    handleDeleteNote,
    handleEditNote,
    setNoteData,
    removeNoteData,
    isNoteEdited,
    isNoteDeleted,
    directInputFocus,
    indirectInputFocus,
    directFocused,
    indirectFocused,
    handleDirectKeyPress,
    handleIndirectKeyPress,
    handleDirectFocus,
    handleIndirectFocus,
    handleDirectBlur,
    handleIndirectBlur,
  };
};
